import React, { useEffect, useRef } from 'react';
import Aos from 'aos';
import { Image, Link, RichText, Text, getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import CustomLink from '../Common/CustomLink';

const StartInvesting = (props) => {
  const confettiCanvasRef = useRef(null); // Reference to the canvas element
  const rewardsWrapperRef = useRef(null); // Reference to the wrapper for calculating width/height

  useEffect(() => {
    // Initialize AOS animation
    Aos.init({
      startEvent: 'scroll',
      offset: 1,
    });

    // Confetti animation logic
    const rewardsWrapper = rewardsWrapperRef.current;
    if (!rewardsWrapper) return; // Prevent errors in SSR if there's no wrapper

    const W = rewardsWrapper.offsetWidth;
    const H = rewardsWrapper.offsetHeight;
    let maxConfettis;
    if (window.innerWidth <= 991) {
      maxConfettis = 10;
    } else {
      maxConfettis = 50;
    }

    const confetticanvas = confettiCanvasRef.current;
    if (!confetticanvas) return;

    const context = confetticanvas.getContext('2d');
    const particles = [];

    const possibleColors = [
      'DodgerBlue',
      'OliveDrab',
      'Gold',
      'Pink',
      'SlateBlue',
      'LightBlue',
      'Gold',
      'Violet',
      'PaleGreen',
      'SteelBlue',
      'SandyBrown',
      'Chocolate',
      'Crimson',
    ];

    function randomFromTo(from, to) {
      return Math.floor(Math.random() * (to - from + 1) + from);
    }

    function confettiParticle() {
      this.x = Math.random() * W; // x
      this.y = Math.random() * H - H; // y
      this.r = randomFromTo(1, 30); // radius
      this.d = Math.random() * maxConfettis + 22;
      this.color = possibleColors[Math.floor(Math.random() * possibleColors.length)];
      this.tilt = Math.floor(Math.random() * 3) - 11;
      this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
      this.tiltAngle = 0;

      this.draw = function () {
        context.beginPath();
        context.lineWidth = this.r / 2;
        context.strokeStyle = this.color;
        context.moveTo(this.x + this.tilt + this.r / 3, this.y);
        context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 6);
        return context.stroke();
      };
    }

    function Draw() {
      const results = [];
      requestAnimationFrame(Draw);
      context.clearRect(0, 0, W, H);

      for (let i = 0; i < maxConfettis; i++) {
        results.push(particles[i].draw());
      }

      let particle = {};
      let remainingFlakes = 0;

      for (let i = 0; i < maxConfettis; i++) {
        particle = particles[i];
        particle.tiltAngle += particle.tiltAngleIncremental;
        particle.y += (Math.cos(particle.d) + 1 + particle.r / 3) / 2;
        particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15;

        if (particle.y <= H) remainingFlakes++;

        if (particle.x > W + 30 || particle.x < -30 || particle.y > H) {
          particle.x = Math.random() * W;
          particle.y = -30;
          particle.tilt = Math.floor(Math.random() * 10) - 20;
        }
      }

      return results;
    }

    // Push new confetti objects to `particles[]`
    for (let i = 0; i < maxConfettis; i++) {
      particles.push(new confettiParticle());
    }

    // Initialize canvas
    confetticanvas.width = W;
    confetticanvas.height = H;
    Draw();

    // Cleanup function
    return () => {
      // Clear the canvas on component unmount
      context.clearRect(0, 0, W, H);
    };
  }, []); // Empty dependency array to run this effect only once (on mount)

  return (
    <section
      className="discover_convenience_new_ui rewardsWrapper growWithabcd_mobApp"
      id="start_investing"
      ref={rewardsWrapperRef}
    >
      <div className="cus-container">
        <div className="dc_new_content_grid">
          <div className="dc_text_wrapper" data-aos="fade-up" data-aos-once="true">
            <div className="dc-sec-heading">
              <h2 className="section-heading heading-flex sec_heading_black">
                <span>
                  <RichText field={props?.fields?.heading} editable />{' '}
                  <span className="font_purp">
                    {' '}
                    <Text field={props?.fields?.subheading1} editable />
                  </span>
                </span>
              </h2>
            </div>
            <p>
              <Text field={props?.fields?.subheading} editable={true} />
            </p>
            <RichText field={props?.fields?.Contents} editable />{' '}
            <div className="download_app_now hidden-xs hidden-sm">
              <span className="down_head">
                <Text field={props?.fields?.subheading2} editable />
              </span>

              <div className="download_btn_ggrid">
                {props?.fields?.appleapplink && (
                  <CustomLink
                    className="know_more_about-us"
                    field={props?.fields?.appleapplink}
                    img={
                      <Image
                        field={props?.fields?.appleappimage}
                        className="dc-apple-store"
                        loading="lazy"
                      />
                    }
                  />
                )}
                {props?.fields?.googleappLink && (
                  <CustomLink
                    className="know_more_about-us"
                    field={props?.fields?.googleappLink}
                    img={
                      <Image
                        field={props?.fields?.googleappimage}
                        className="dc-play-store"
                        loading="lazy"
                      />
                    }
                  />
                )}
              </div>
            </div>
          </div>
          <div className="dc_image_wrapper">
            <div className="dc_download_scnner_Wrapper">
              <Image field={props?.fields?.image2} height="140" width="140" loading="lazy" />
              <p>
                <Text field={props?.fields?.subheading3} editable />
              </p>
            </div>
            <Image
              field={props?.fields?.image1}
              className="mob_app_img"
              height="783"
              width="783"
              loading="lazy"
            />
          </div>

          <div className="download_app_now hidden-lg hidden-md">
            <span className="down_head">
              <Text field={props?.fields?.subheading2} editable />
            </span>
            <div className="download_btn_ggrid">
              {props?.fields?.appleappimage && (
                <CustomLink
                  className="know_more_about-us"
                  field={props?.fields?.appleapplink}
                  img={
                    <Image
                      field={props?.fields?.appleappimage}
                      className="dc-apple-store"
                      loading="lazy"
                    />
                  }
                />
              )}
              {props?.fields?.googleappLink && (
                <CustomLink
                  className="know_more_about-us"
                  field={props?.fields?.googleappLink}
                  img={
                    <Image
                      field={props?.fields?.googleappimage}
                      className="dc-play-store"
                      loading="lazy"
                    />
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <canvas id="confetticanvas" ref={confettiCanvasRef}></canvas>
    </section>
  );
};

export default StartInvesting;
